import styled from 'styled-components';

import {Device} from '../../../../constants';

export const StyledVBucksThreeColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 2;

  @media screen and ${Device.laptop} {
  }

  @media screen and ${Device.tablet} {
    flex-direction: column;
    margin-top: 50px;
    margin-bottom 2em;
  }
`;

export const StyledVBucksThreeColumnImgContainer = styled.div<{direction: 'left' | 'right'}>`
  width: 100%;
  height: auto;
  flex-basis: 100%;
  position: relative;
  display: flex;
  justify-content: ${({direction}) => (direction === 'left' ? `flex-start` : 'flex-end')};
  padding-top: 2em;

  img {
    transform: translate(0, 0);
    width: 70%;
    height: auto;

    @media screen and ${Device.laptopL} {
      width: 100%;
    }
  }

  @media screen and ${Device.tablet} {
    width: 100%;

    img {
      width: 100%;
    }
  }
`;

export const StyledVbucksContentCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  && h2 {
    font-size: 4em;
  }

  && p {
    font-size: 1.2em;
    padding: 0 5em;
  }

  @media screen and ${Device.laptop} {
    padding: 0;

    && h2 {
      font-size: 3em;
    }

    && p {
      font-size: 1em;
      padding: 0;
    }
  }

  @media screen and ${Device.tablet} {
    position: unset;
    width: 100%;
    padding: 1em;
  }
`;
